/**
 * `/plans` — plan selection.
 *
 * One `RouteObject`, so the file is `plans.route.tsx` (singular); the
 * feature's three routes are gathered by `subscription.routes.tsx` (plural),
 * and the importer knows each shape from its name.
 *
 * The route resolves nothing and fetches nothing: **no `loader` in this repo
 * performs a data read.** The page component owns its reads, so there is one
 * cache and one invalidation story.
 *
 * The chunk is split through the router's OWN `lazy` rather than
 * `React.lazy` — the data router awaits it before rendering the match, so the
 * feature needs no `Suspense` boundary of its own. All three subscription
 * routes resolve into the same lazy group, which is the `chunk-subscription`
 * budget row.
 */
import type { RouteObject } from 'react-router-dom';

export const plansRoute: RouteObject = {
  path: 'plans',
  lazy: async () => {
    const { PlansPage } = await import('./Plans');
    return { Component: PlansPage };
  },
};
